import { ICreateAlert, IGetAlerts } from "../../components/Alert/type";
import APIService from "./API.service";
const queryString = require("query-string");

class AlertService extends APIService {
  getAlerts(params: IGetAlerts) {
    const query = {
      token: localStorage.getItem("fielddrive-token"),
    };
    return this.call.get(
      `${this.apiUrl}/events/${params.id}/alerts?${queryString.stringify(query)} ` 
    );
  }
  createEvent(params: ICreateAlert, eventId: number) {
    const query = {
      token: localStorage.getItem("fielddrive-token"),
    };
    return this.call.post(
      `${this.apiUrl}/events/${eventId}/alerts?${queryString.stringify(query)}`,
      JSON.stringify(params)
    );
  }
  updateEvent(params: ICreateAlert, eventId: number, id: number) {
    const query = {
      token: localStorage.getItem("fielddrive-token"),
    };
    return this.call.put(
      `${this.apiUrl}/events/${eventId}/alerts/${id}?${queryString.stringify(query)}`,
      JSON.stringify({...params, disabled : params.disabled ? true : false})
    );
  }
  deleteAlert(id: number, eventId: number) {
    try {
      const query = {
        token: localStorage.getItem("fielddrive-token"),
      };
      return this.call.delete(
        `${this.apiUrl}/events/${eventId}/alerts/${id}?${queryString.stringify(query)}`
      );
    } catch (error) {
      console.log(error, "error");
    }
  }
}

export default AlertService;
